export default {
  meta: {
    title: '月报提交记录',
    url: '/abside/monthrecord', // 埋点字段，上报归属的模块
    urlName: 'ab侧-月报提交记录', // 埋点字段，上报归属的模块
    logincallback: '/abside',
  }
};
